import { http } from '../shared/api';

export const listTargetPeriods = (config) => http.get('/api/climate-action/targets', config);

export const getTargetPeriod = (targetId, config) => http.get(
  `/api/climate-action/targets/${targetId}`,
  config,
);

export const createTargetPeriod = (body) => http.post('/api/climate-action/targets', body);

export const updateTargetPeriod = (targetId, body) => http.put(
  `/api/climate-action/targets/${targetId}`,
  body,
);

export const archiveTargetPeriod = (targetId) => http.post(
  `/api/climate-action/targets/${targetId}/archive`,
);

export const deleteTargetPeriod = (targetId) => http.delete(
  `/api/climate-action/targets/${targetId}`,
);

export const resolveTargetPeriod = (fiscalYear, config) => http.get(
  '/api/climate-action/targets/resolve',
  { ...config, params: { fiscal_year: Number(fiscalYear) } },
);

export const listBaselineYears = (config) => http.get(
  '/api/climate-action/targets/baseline-years',
  config,
);

export const getDashboardTargetSlice = (fiscalYear, config) => http.get(
  '/api/climate-action/dashboard',
  { ...config, params: { fiscal_year: Number(fiscalYear) } },
);